import { useEffect, useRef, useCallback, useState } from 'react';
import { SUPPORT_BASE_WS_URL } from '../config/config';

export const useSupportSocket = (userId, parentId) => {
  const wsRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const messageHandlers = useRef([]);
  const isManualClose = useRef(false);

  useEffect(() => {
    if (!userId || !parentId) return;

    const ws = new WebSocket(`${SUPPORT_BASE_WS_URL}/chat`);
    wsRef.current = ws;

    ws.onopen = () => {
      isManualClose.current = false;
      setIsConnected(true);

      const subscribePayload = {
        type: 'SUBSCRIBE',
        userId: Number(userId),
        parentId: Number(parentId),
      };
      ws.send(JSON.stringify(subscribePayload));
    };


ws.onmessage = (event) => {
  try {
    const msg = JSON.parse(event.data);

    if (msg.type === 'ERROR') return;

  
if (msg.type === 'MESSAGE_DELETED') {
  messageHandlers.current.forEach(cb =>
    cb({
      type: 'MESSAGE_DELETED',
      messageIds: msg.messageIds || (msg.messageId ? [msg.messageId] : []),
    })
  );
  return;
}

    if (msg.messages && Array.isArray(msg.messages)) {
      const filtered = msg.messages.filter(
        m => !m.deleted && m.content !== '[Deleted by Master]'
      );
      messageHandlers.current.forEach(cb =>
        cb({ type: 'HISTORY', messages: filtered })
      );
      return;
    }

    if (msg.type === 'SUBSCRIBED') return;

    messageHandlers.current.forEach(cb => cb(msg));
  } catch (err) {
    console.error('WebSocket message parse error:', err);
  }
};

    ws.onerror = () => {};
    ws.onclose = () => {
      setIsConnected(false);
    };

    return () => {
      isManualClose.current = true;
      ws.close();
      messageHandlers.current = [];
    };
  }, [userId, parentId]);

  const onMessage = useCallback((callback) => {
    if (typeof callback === 'function') {
      messageHandlers.current.push(callback);
    }
    return () => {
      messageHandlers.current = messageHandlers.current.filter(cb => cb !== callback);
    };
  }, []);

  const sendMessage = useCallback((payload) => {
    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) return false;

    try {
      const messageToSend = {
  type: payload.type || 'CHAT',
  content: payload.content || payload.message || '',

  ...(payload.type === 'FILE' && {
    fileName: payload.fileName,
    fileData: payload.fileData,
    fileSize: payload.fileSize,
    fileType: payload.fileType,
  }),
};
      wsRef.current.send(JSON.stringify(messageToSend));
      return true;
    } catch (err) {
      return false;
    }
  }, [userId, parentId]);

  return { sendMessage, onMessage, isConnected };
};